import {
    UPDATE_RULE,
    UPDATE_RULE_FAIL,
    UPDATE_RULE_STATUS,
    UPDATE_RULE_STATUS_FAIL,
    UPDATE_RULE_STATUS_SUCCESS,
    UPDATE_RULE_SUCCESS
} from './actionTypes';

const initialState = {
    ruleToUpdate: {},
    updatedRule: {},
    loaded: false,
    loading: false,
    error: null
};

export function updateRuleReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_RULE:
        case UPDATE_RULE_STATUS:
            return {
                ...initialState,
                ruleToUpdate: action.payload,
                loading: true
            };
        case UPDATE_RULE_SUCCESS:
        case UPDATE_RULE_STATUS_SUCCESS:
            return {
                ...state,
                updatedRule: action.payload,
                loading: false,
                loaded: true
            };
        case UPDATE_RULE_FAIL:
        case UPDATE_RULE_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
}
